// extracted by mini-css-extract-plugin
module.exports = {"shadow":"BoxShadow_shadow__9C6lH"};